import { HAS_DISMISSED_PLAN_TRIAL_BANNER, useUserSpecificLocalStorage } from '../../../hooks/use-local-storage';
import { addPeriodOfTime, getCurrentDateTime } from '../../../services/datetime-service';

const SEVEN_DAYS = { period: 'days', value: 7 };

/**
 * Has the current user dismissed the BillingPlanTrialBanner for this specific tier
 * in the previous 7 days (via localStorage)
 */
export const useHasDismissedBanner = (currentPlanCode: string): boolean => {
  // Key includes planCode so each tier has its own dismissal state
  const planSpecificKey = `${HAS_DISMISSED_PLAN_TRIAL_BANNER}/${currentPlanCode}`;
  const [dismissedAtISO] = useUserSpecificLocalStorage(planSpecificKey);

  if (!dismissedAtISO || !currentPlanCode) {
    return false;
  }

  // Value is ISO string (DateTime object was JSON.stringified on write)
  const lastDismissalPlusSevenDays = addPeriodOfTime(dismissedAtISO, SEVEN_DAYS);
  const now = getCurrentDateTime();
  return lastDismissalPlusSevenDays > now;
};
